import React, { useContext } from "react";
import { Photo } from "./types";
import { RemoveFromCartIcon } from "./vectors/LightBoxCartIcons";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const RemoveFromCartButton = ({
  colorTheme,
  onRemoveFromCart,
  photo
}: {
  colorTheme: string;
  onRemoveFromCart: Function;
  photo: Photo;
}) => {
  return (
    <div
      onClick={e => {
        e.preventDefault();
        onRemoveFromCart(photo);
      }}
      className="btn-rem-cart geo-btn--caps"
      style={{
        border: `1px solid ${ContrastForegroundUtility.lbFgColor(colorTheme)}`
      }}
    >
      <RemoveFromCartIcon
        color={ContrastForegroundUtility.lbFgColor(colorTheme)}
      />
      <span
        style={{
          color: ContrastForegroundUtility.lbFgColor(colorTheme)
        }}
      >
        &nbsp; Remove
      </span>
    </div>
  );
};

export default RemoveFromCartButton;
